import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Ranking from './components/Ranking';
import FAQ from './components/FAQ';
import Updates from './components/Updates';
import Index from './components/Index';
import Carousel from './components/Carousel';
import Contact from './components/Contact';
import Comments from './components/Comments';
import Media from './components/Media';
import Cards from './components/Cards';
import App from './components/App';
import Features from './components/Features';
import Topics from './components/Topics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <About />
        <Ranking />
        <FAQ />
        <Updates />
        <Index />
        <Carousel />
        <Contact />
        <Comments />
        <Media />
        <Cards />
        <App />
        <Features />
        <Topics />
      </main>
      <Footer />
    </div>
  );
}